var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ripa-form-template"},[_c('ripa-form-wrapper',_vm._g({model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }